<template>
    <div>
        <!--  <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Student Fees Invoice</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                 <v-col cols="3" sm="2" md="2">
                    <v-autocomplete rounded :items="aylist" label="Academic Year" item-text="academicyear" item-value="ay_id" outlined dense v-model="ay" @change="getInstallment()"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-autocomplete v-model="selected_children" rounded :items="stud_list" item-value="lid" label="Select Student" item-text="name" @change="putNull()" outlined dense ></v-autocomplete>
                </v-col>
                 <v-col cols="12" sm="2" md="2">
                    <v-autocomplete v-model="semester" rounded :items="semester_list" item-value="id" label="Select Semester" item-text="sem" outlined dense ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="installment_list!=''">
                    <v-autocomplete v-model="installment" multiple rounded :items="installment_list" item-value="id" label="Select Installment" item-text="name" outlined dense ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-text-field outlined dense type="date" label="Due Date" v-model="due_date"></v-text-field>
                </v-col>
                 <v-col cols="12" sm="2" md="2">
                    <v-text-field outlined dense type="date" label="Invoice Date" v-model="invoice_date"></v-text-field>
                </v-col>
            </v-row>
                 <v-row justify="center">
                     <v-col cols="2">
                <v-btn class="ma-2" rounded color="orange" :loading="loader" v-if="selected_children && ay && semester && installment" @click="getDetails()">Proceed</v-btn>
                     </v-col>

                  <v-col cols="2" v-if="student_component_list!=''">
                    <v-btn class="ma-2" rounded color="success" @click="expand = !expand">
                        Previous Invoices
                    </v-btn>
                </v-col>
                 </v-row>
        </v-card>

        <!-- <v-row justify="center" v-if="student_component_list!=''"> -->
        <v-expand-transition>
                    <v-card v-show="expand" class="box">
                        <v-toolbar dense class="toolbar" flat color="white">
                            <v-toolbar-title>Student Previous Invoices</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <br />
                        <template v-if="student_invoice_list != ''">
                            <v-data-table :items="student_invoice_list" :headers="headers" class="elevation-1 mytable" dense :search="search">
                                 <template v-slot:[`item.is_active`]="{ item }">
                                    <v-switch v-model="item.is_active" @change="toggle(item)"></v-switch>
                                </template>
                                <template v-slot:[`item.invoice_number`]="{ item }">
                                    <v-tooltip top color="warning">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="pt-none mt-none" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print(item.id,item.academicyear_id)"> <v-icon color="warning">mdi-printer</v-icon>{{item.invoice_number}}</v-btn>
                                        </template>
                                        <span>
                                            Print Challan!!!
                                        </span>
                                    </v-tooltip>
                                </template>
                                <template v-slot:[`item.send_mail`]="{ item }">
                                    <v-tooltip top color="warning">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn :loading="loader" class="pt-none mt-none" outlined rounded small color="green" v-bind="attrs" v-on="on" @click="send_mail(item.id,item.academicyear_id)"> <v-icon color="green">mdi-gmail</v-icon>{{item.invoice_number}}</v-btn>
                                        </template>
                                        <span>
                                            Send Invoice Mail!!!
                                        </span>
                                    </v-tooltip>
                                </template>
                                 <template v-slot:[`item.pay`]="{ item }">
                                 <div v-if="!item.is_paid">
                                    <v-tooltip top color="warning">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="pt-none mt-none" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="pay(item)">Pay</v-btn>
                                        </template>
                                        <span>
                                            Pay
                                        </span>
                                    </v-tooltip>
                                  </div>
                                  <div v-else class="text">
                                        <strong>Already Paid</strong>
                                    </div>
                                </template>
                                 <template v-slot:[`item.pay_fee`]="{ item }">
                                    <div v-if="!item.is_paid">
                                        <input placeholder="Enter Amount." class="input text-center" type="number" v-model="item.pay_fee" :name="item.pay_fee" :rules="[(v) => !!v || 'Required' || v >= 0]" />
                                    </div>
                                    <div v-else class="text">
                                        <strong>Already Paid</strong>
                                    </div>
                                </template>
                                 <template v-slot:[`item.bank`]="{ item }">
                                    <div v-if="!item.is_paid">
                             <v-autocomplete class="mt-3" dense rounded required :items="bank_list" v-model="item.bank" label="Bank" name="bank" item-text="name" item-value="name" outlined></v-autocomplete>
                                    </div>
                                    <div v-else class="text">
                                        <strong>Already Paid</strong>
                                    </div>
                                </template>
                                 <template v-slot:[`item.branch`]="{ item }">
                                    <div v-if="!item.is_paid">
                                        <v-text-field class="mt-3" outlined rounded label="Branch Name" v-model="item.branch" placeholder="SBU Pune" name="branch_name" dense></v-text-field>
                                    </div>
                                    <div v-else class="text">
                                        <strong>Already Paid</strong>
                                    </div>
                                </template>
                                <template v-slot:[`item.pay_date`]="{ item }">
                                    <div v-if="!item.is_paid">
                                        <input id="datePickerId" type="date" v-model="item.pay_date" />
                                    </div>
                                    <div v-else class="text">
                                        <strong>Already Paid</strong>
                                    </div>
                                </template>
                                <template v-slot:[`item.trxn_date`]="{ item }">
                                    <div v-if="!item.is_paid">
                                        <input id="datePickerId" type="date" v-model="item.trxn_date" />
                                    </div>
                                    <div v-else class="text">
                                        <strong>Already Paid</strong>
                                    </div>
                                </template>
                                <template v-slot:[`item.remark`]="{ item }">
                                    <div v-if="!item.is_paid">
                                        <input placeholder="Enter Remark." class="input text-center" type="text" v-model="item.remark" :name="item.remark" :rules="[(v) => !!v || 'Required' || v >= 0]" />

                                        <!-- <v-text-field class="mt-none pt-none" rounded label="Enter Remark" hide-details="auto" v-model="item.remark" outlined dense></v-text-field> -->
                                    </div>
                                    <div v-else class="text">
                                        <strong>Already Paid</strong>
                                    </div>
                                </template>
                                <template v-slot:[`item.trxn_id`]="{ item }">
                                    <div v-if="!item.is_paid">
                                        <input placeholder="Transaction Id." class="input text-center" type="text" v-model="item.trxn_id" :name="item.trxn_id" :rules="[(v) => !!v || 'Required' || v >= 0]" />
                                    </div>
                                    <div v-else class="text">
                                        <strong>Already Paid</strong>
                                    </div>
                                </template>
                                 <template v-slot:[`item.select_payment_mode`]="{ item }">
                                    <div v-if="!item.is_paid">
                                        <!-- <v-autocomplete v class="mb-none pb-none mt-4" color="#0F2027" dense rounded required v-model="item.select_mode" :items="payment_modes" item-text="payment_mode_name" item-value="paymentmode_id" label="Payment Mode" outlined /> -->
                                        <!-- <lable>Select Payment Mode</lable> -->
                                        <select class="select" v-model="item.select_mode" name="name" id="id" data-live-search="true" data-show-subtext="true">
                                            <option value="0">--Please select payment mode</option>
                                            <option v-for="p in payment_mode_list" :value="p">
                                                {{ p.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-else class="text">
                                        <strong>Already Paid</strong>
                                    </div>
                                </template>

                                <template v-slot:[`item.print`]="{ item }">
                                  <span v-if="item.receipt_no">
                                    <v-tooltip top color="warning">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print_receipt(item.receipt_no, item.academicyear_id,item.registration_number)"> <v-icon color="warning">mdi-printer</v-icon>{{item.receipt_no}}</v-btn>
                                        </template>
                                        <span> Print Fee Receipt!!! </span>
                                    </v-tooltip>
                                    </span>
                                    <span v-else>--</span>
                                </template>

                                 <template v-slot:[`item.action`]="{ item }">
                                    <v-row dense>
                                    <span v-if="!item.is_paid">
                                        <v-icon small class="mr-2 edit-v-icon" @click="editInvoice(item)" title="edit">edit</v-icon>
                                    <v-icon small class="mr-4 v-icon-size" color="red" @click="showReason(item.id)" :loading="loader">mdi-trash-can</v-icon>                                 
                                </span>
                                <span v-else>
                                    <strong>Cannot Edit / Delete</strong>
                                </span>
                                    <!-- <span v-else class="text">
                                        <strong>Cannot Delete</strong>
                                    </span> -->
                                    </v-row>
                                </template>

                            </v-data-table>
                        </template>
                    </v-card>
                </v-expand-transition> 
        <!-- </v-row> -->

        <!-- {{student_component_list}} -->
          <v-card class="box" v-if="student_component_list!=''">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Fees Components</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-col cols="12" sm="12" md="12">
                <v-simple-table dense class="elevation-1 mytable">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>Sr No</th>
                                <th>Component/Head</th>
                                <th>Term Due</th>
                                <th>Waiver</th>
                                <th>Due Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(comp,index) in student_component_list" :key="comp.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ comp.name }}</td>
                                <td>{{ comp.term_due_amount }}</td>
                                <!-- <td>{{ comp.waiver_amount }}</td> -->
                                <td>
                                <input placeholder="Enter Amount." class="input text-center" type="number" v-model="comp.waiver_amount" :name="comp.id" :rules="[v => !!v || 'Required' || v >= 0]" @change="check_ammount(comp)" />
                                </td>
                                <td>{{ comp.due_amount }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-row dense justify="center"> <v-btn :loading="loader" color="orange" class="button mt-9" @click="generateChallan(student_component_list)">Generate Invoice</v-btn></v-row>
            </v-col>
        </v-card>
         <v-dialog v-model="show_reason" max-width="1000px">
                <v-card>
                    <v-toolbar class="toolbar no-display" flat dense>
                        <v-toolbar-title>
                            <strong> Add Remark </strong>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn fab small color="white" outlined icon @click="show_reason = false"><v-icon> mdi-close </v-icon></v-btn>
                    </v-toolbar>
                    <v-row dense justify="center">
                        <v-col cols="12" sm="6" md="6">
                            <p><b>Remark</b></p>
                            <v-textarea outlined name="input-7-4" v-model="addRemark" label="Enter Remark"> </v-textarea>
                        </v-col>
                    </v-row>
                    <!-- receipt id-{{ receipt_id }} <br /> -->
                    <center>
                        <strong>Are you sure you want Delete this Receipt???</strong>
                    </center>
                    <v-row justify="center">
                        <v-btn class="button" text @click="show_reason = false">No</v-btn>
                        <v-btn class="button" text :disabled="addRemark != '' ? false : true" @click="deleteStudentInvoice(addRemark)">Yes</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
        <v-dialog v-model="dialog_edit" fullscreen>
         <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Student Otstanding Fees
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog_edit=false"><v-icon> mdi-close </v-icon></v-btn>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                <v-simple-table dense class="elevation-1 mytable">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>Sr No</th>
                                <th>Component/Head</th>
                                <th>Term Due</th>
                                <th>Waiver</th>
                                <th>Due Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(comp,index) in student_challan_details" :key="comp.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ comp.name }}</td>
                                <td>{{ comp.term_due_amount }}</td>
                                <td>
                                <input placeholder="Enter Amount." class="input text-center" type="number" v-model="comp.waiver_amount" :name="comp.id" :rules="[v => !!v || 'Required' || v >= 0]" @change="check_ammount(comp)" />
                                </td>
                                <td>{{ comp.due_amount }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-row dense justify="center"> <v-btn :loading="loader" color="orange" class="button mt-9" @click="updateInvoice(student_challan_details)">Update Invoice</v-btn></v-row>
            </v-col>
                <v-row justify="center">
                    <v-btn class="button no-display" @click="dialog_edit=false">Cancel</v-btn>
                </v-row>  
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            dialog_edit:false,
            student_challan_details:[],
            addRemark:'',
            invoice_id:null,
            show_reason:false,
            due_date: new Date().toISOString().slice(0, 10),
            invoice_date: new Date().toISOString().slice(0, 10),
            selected_children: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: false,
            current_ay: "",
            search: "",
            s3url: "",
            installment_list: [],
            installment: null,
            show_details_card: false,
            expand: false,
            expand1: false,
            headers: [
                { text: "Status", value: "is_active", sortable: true },
                { text: "Invoice No", value: "invoice_number", sortable: true },
                { text: "Send Mail", value: "send_mail", sortable: true },
                { text: "Student", value: "learner", sortable: true },
                // { text: "Date", value: "invoice_date", sortable: true },
                //  {text: "Installment", value: "feesinstallmentacademicyear", sortable: true},
                 { text: "Date", value: "pay_date", width: 200 },
                 { text: "Transaction Id", value: "trxn_id", width: 200 },
                { text: "Payment Mode", value: "select_payment_mode", width: 200 },
                { text: "Bank", value: "bank", width: 200 },
                { text: "Branch Name", value: "branch", width: 200 },
                { text: "Transaction Date", value: "trxn_date", width: 200 },
                { text: "Remark", value: "remark", width: 200 },
                { text: "Pay", value: "pay", sortable: true },
                { text: "Print Receipt", value: "print", sortable: true },
                { text: "Action", value: "action", sortable: true },
            ],
            headers_installment: [
                { text: "Sr. No.", value: "srno", sortable: true },
                { text: "Payment Stage", value: "installment", sortable: true },
                { text: "Amount", value: "total_fees_amount", sortable: true },
                { text: "Fine", value: "fine", sortable: true },
                { text: "Deadline", value: "due_date", sortable: true },
            ],
            components_value: [],
            components_id: [],
            receipt_amount: 0,
            bank_list: [],
            bank: null,
            mode_date: null,
            cheque_dd_no: null,
            challan_no: null,
            ay: null,
            challan_status_list:[],
            challan_status:null,
            stud_list: [],
            aylist: [],
            ay: "",
            semester_list:[],semester:"",installment_list:[],installment:null,student_component_list:[],components_waiver_value:[],
            student_invoice_list:[],payment_mode_list:[],edit_invoice_id:null,
        }),

        methods: {
            async getInstallment(){
                this.installment_list = []
                this.installment = null
                const data={
                    ay:this.ay
                }
                axios
                    .post("FeesStructureInstallment/getFeesInstallmentAcademicYear", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            if (res.data.installment_list.length <= 0) {
                                this.showSnackbar("#b71c1c", "No Installments Available");
                                return;
                            }
                            this.installment_list = res.data.installment_list;
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            async toggle(item){
                  const data = {
                    invoice: item,
                };
                try {
                    const res = await axios.post("/GenerateChallan/update_invoice_status", data);
                    if (res.data.flag == "YES") {
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    this.showSnackbar("red", "Something Went Wrong !!!");
                } finally {
                }
            },
            putNull(){
                this.student_invoice_list=[],this.show_details_card=false,this.student_component_list=[]
            }, 
             updateInvoice(installment_details_list) {
                this.loader=true
                for (var i = 0; i < installment_details_list.length; i++) {
                        if(installment_details_list[i].due_amount > installment_details_list[i].term_due_amount){
                            this.showSnackbar("#b71c1c", "Due Amount Should Be Less Than Term Due Amount");
                            return;
                        }
                        this.components_id.push(installment_details_list[i].id);
                        this.components_waiver_value.push(installment_details_list[i].waiver_amount);
                        this.components_value.push(installment_details_list[i].due_amount);
                }
                const formData = {
                    edit_invoice_id:this.edit_invoice_id,
                    components_value: this.components_value,
                    components_id: this.components_id,
                    components_waiver_value: this.components_waiver_value,
                };
                axios
                    .post("GenerateChallan/updateLearnerFeesInvoice", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", " Challan Generated Successfully..");
                             this.loader=false
                            this.clearData();
                        }
                        if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.clearData();
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.clearData();
                    })
                    .finally(() => {
                        this.loader=false
                        this.dialog_edit=false
                        this.clearData();
                        this.getDetails();
                    });
            },
            editInvoice(item){
                this.edit_invoice_id=item.id
                const formData = {
                    id:item.id,
                };
                this.loader=true
                axios
                    .post("GenerateChallan/editInvoice", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.student_challan_details=res.data.student_challan_details
                            this.dialog_edit=true
                        }
                        if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
             showReason(item) {
                this.show_reason = true;
                this.invoice_id = item;
            },
             deleteStudentInvoice(addRemark) {
            // if (!confirm("Are You Sure You Want To Delete Invoice.....?")) return;
            const formData = {
                    id:this.invoice_id,
                    reason_for_delete:addRemark,
                };
                this.loader=true
                axios
                    .post("GenerateChallan/deleteStudentInvoice", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                          this.showSnackbar("green", "Invoice Deleted Successfully...");
                        }
                        if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        this.loader = false;
                        this.addRemark='',this.show_reason=false,
                        this.getDetails();
                    });
            },
             print_receipt(receipt_no, ay,registration_number) {
                this.receipt_no = receipt_no;
                // this.dialog_print = true;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(registration_number));
                // this.$router.push({
                //     name: "student-fees-receipts",
                // });

                // alert(this.org_id)
                if (this.org_id == "zeal") {
                    let routeData = this.$router.resolve({ name: "zeal-student-receipt" });
                    window.open(routeData.href, "_blank");
                } else if (this.org_id == "wws") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-wws",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (this.org_id == "uwws") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-uwws",
                    });
                    window.open(routeData.href, "_blank");
                }
                 else if (this.org_id == "vvp") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-vvp",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (this.org_id == "sanjivani") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-sanjivani",
                    });
                    window.open(routeData.href, "_blank");
                }
                 else {
                    let routeData = this.$router.resolve({ name: "student-fees-receipts" });
                    window.open(routeData.href, "_blank");
                }
            },
            pay(item) {
                // alert("payment mode: "+ JSON.stringify(item.select_mode))
                 if (!confirm("Are You Sure You Want To Pay Invoice Fees.....?")) return;
                 if(item.select_mode == null || item.select_mode==''){
                    this.showSnackbar("#b71c1c", "Please Select Payment Mode...");
                    return
                 }
                //  if(item.trxn_id == null || item.trxn_id==''){
                //     this.showSnackbar("#b71c1c", "Please Select Transaction Id ..");
                //     return
                //  }
                 if(item.pay_date == null || item.pay_date==''){
                    this.showSnackbar("#b71c1c", "Please Select Transaction Date ..");
                    return
                 }
                //  if(item.bank == null || item.bank==''){
                //     this.showSnackbar("#b71c1c", "Please Select Bank ..");
                //     return
                //  }
                //  if(item.branch == null || item.branch==''){
                //     this.showSnackbar("#b71c1c", "Please Enter Bank Branch Name ..");
                //     return
                //  }
                this.loader=true
                axios
                    .post("GenerateChallan/payStudentFeesInvoiceAmount", item)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.student_component_list=res.data.fees_components_details
                            this.student_invoice_list=res.data.student_invoice_list,
                            this.payment_mode_list=res.data.payment_mode_list
                            this.showSnackbar("green", "Paid Successfully...");
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            check_ammount(comp){
                  if(comp.waiver_amount > comp.term_due_amount){
                        this.showSnackbar("#b71c1c", "Waiver Amount Should Be Less Than Due Amount");
                        return;current_amount
                    }
                    comp.due_amount=comp.term_due_amount-comp.waiver_amount
                    return comp
            },
            send_mail(challan_no, academicyear){
                this.loader = true
                const data = {
                    challan_no : challan_no,
                    academicyear: academicyear,
                    reg_no:this.selected_children
                }
                axios
                    .post("GenerateChallan/sendInvoiceMail", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", " Mail Send Successfully..");
                            this.loader=false
                        }
                        if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        this.loader=false
                    });
            },
            print(challan_no, academicyear) {
                //alert(receipt_no)
                this.challan_no = challan_no;
                this.ay = academicyear;
                this.dialog_print = true;
                // this.overlay = true
                this.$session.set("challan_no", JSON.stringify(challan_no));
                this.$session.set("ay", JSON.stringify(this.ay));
                this.$session.set("registration_no", JSON.stringify(this.selected_children));
                let routeData = this.$router.resolve({name: 'learner-fees-invoice-print'});
                window.open(routeData.href, '_blank');
            },
            clearData() {
                this.student_challan_details = [];
                this.fees_student_master_details = [];
                this.student_receipt_details = [];
                this.show_details_card = false;
                this.show_receipts_btn = false;
                this.show_installments_btn = false;
               // this.installment_list = [];
                this.mode_list = [];
                this.bank_list = [];
                this.challan_status_list=[];
                this.challan_status=null;
                this.installment_details_list = [];
                this.stud_name = null;
                this.comp_total = "";
                this.stud_id = "";
                (this.components_value = []), (this.components_id = []), (this.receipt_amount = 0);
                (this.mode = null), (this.bank = null), (this.cheque_dd_no = null), (this.mode_date = null); this.components_waiver_value=[]
            },
            generateChallan(installment_details_list) {
                this.loader=true
                for (var i = 0; i < installment_details_list.length; i++) {
                    // if (installment_details_list[i].term_due_amount > 0) {
                        if(installment_details_list[i].due_amount > installment_details_list[i].term_due_amount){
                            this.showSnackbar("#b71c1c", "Due Amount Should Be Less Than Term Due Amount");
                            return;
                        }
                        this.components_id.push(installment_details_list[i].id);
                        this.components_waiver_value.push(installment_details_list[i].waiver_amount);
                        this.components_value.push(installment_details_list[i].due_amount);
                    // }
                }
                const formData = {
                    learner: this.selected_children,
                    ay:this.ay,
                    registration_no: this.selected_children,
                    components_value: this.components_value,
                    components_id: this.components_id,
                    components_waiver_value: this.components_waiver_value,
                    ay:this.ay,
                    semester:this.semester,
                    installment:this.installment,
                    due_date:this.due_date,
                    invoice_date:this.invoice_date
                };
                axios
                    .post("GenerateChallan/generateLearnerFeesInvoice", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", " Challan Generated Successfully..");
                            // this.challan_no = res.data.challan_no;
                            // this.ay = res.data.ay;
                            // this.$session.set("challan_no", JSON.stringify(this.challan_no));
                            // this.$session.set("ay", JSON.stringify(this.ay));
                            // this.$session.set("registration_no", JSON.stringify(this.selected_children));
                            // let routeData = this.$router.resolve({name: 'student-generate-challan'});
                            // window.open(routeData.href, '_blank');
                             this.loader=false
                            this.clearData();
                        }
                        if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.clearData();
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.clearData();
                    })
                    .finally(() => {
                        this.loader=false
                        this.getDetails();
                        this.clearData();
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getDetails() {
                const formData = {
                    registration_no: this.selected_children,
                    ay:this.ay,
                    semester:this.semester,
                    installment:this.installment
                };
                this.loader=true
                axios
                    .post("GenerateChallan/getLearnerComponentsSelection", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.student_component_list=res.data.fees_components_details
                            this.student_invoice_list=res.data.student_invoice_list,
                            this.payment_mode_list=res.data.payment_mode_list
                            this.bank_list = res.data.bank_list
                        }
                        if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            onload() {
                axios
                    .post("FeesStructureInstallment/getdata")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.aylist = res.data.aylist), 
                            (this.ay = res.data.current_ay);
                            this.stud_list = res.data.stud_list;
                            this.semester_list = res.data.semester_list;
                            this.getInstallment()
                          //  this.installment_list = res.data.installment_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
        },

        mounted() {
             this.onload();
            this.org_id = localStorage.getItem("EPS-tenant");
            // datePickerId.min = new Date().toISOString().split("T")[0];
        },
    };
</script>

<style scoped>
  .select {
      width: 100%;
      display: inline-block;
      border: 1px solid black;
      border-radius: 4px;
      box-sizing: border-box;
  }
input[type="text"] {
      width: 100%;
      display: inline-block;
      border: 1px solid black;
      border-radius: 4px;
      box-sizing: border-box;
  }
input[type=number] {
  width: 50%;
  display: inline-block;
  border: 1px solid black;
  border-radius: 4px;
  box-sizing: border-box;
}

    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .datepicker-div {
        margin-top: none !important;
    }
    .datepicker-div label {
        color: #00000099;
        font-size: 12px;
        position: relative;
    }
     input[type="date"] {
      width: 100%;
      display: inline-block;
      padding: 0.3rem;
      border: 1px solid gray;
      border-radius: 30px;
      box-sizing: border-box;
      padding-top: none !important;
      margin-top: none !important;
  }
</style>
